import React, { useEffect, useState, useRef } from "react";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { getAssetURL } from "../../utils";
import content from "../../includes/content";

const PageThree = ({ setError, error, onSubmit }) => {
  const ssnOne = useRef();
  const ssnTwo = useRef();
  const ssnThree = useRef();
  const ssnFour = useRef();
  const [userSSN, setUserSSN] = useState({
    one: "",
    two: "",
    three: "",
    four: "",
  });
  useEffect(() => {
    ssnOne.current.focus();
  }, []);
  const handleKeyDown = (e, ref) => {
    const ssnInput = e.target.id;
    const key = e.key;
    if (key === "Enter") {
      onSubmit(e, userSSN);
    } else if (key === "Backspace") {
      if (userSSN[ssnInput] !== "") {
        setUserSSN((prev) => ({
          ...prev,
          ssnInput: "",
        }));
      } else {
        ref.current.focus();
      }
    }
  };

  return (
    <Container className="main fadeIn">
      <Row>
        <Col className="text-space order-2 order-lg-1" lg={6}>
          <h3 className="d-flex justify-content-center align-items-center">
            {content.mainHeadline}
          </h3>
          <h1 className="d-flex justify-content-center align-items-center cert">
            CERTIFICATE
          </h1>

          <Form className="d-flex justify-content-center align-items-center">
            <div className="form-style  bottom-margin">
              <Image
                className="mobileWings"
                src={getAssetURL("mobile-wings.svg")}
              />
              <p className="form-title ">
                Please enter the last
                <br /> 4 digits of your SSN
              </p>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="inputs-box d-flex justify-content-center align-items-center">
                  <div>
                    <input
                      ref={ssnOne}
                      className="ssn-input"
                      type="number"
                      pattern="\d"
                      id="one"
                      value={userSSN.one}
                      onKeyDown={(e) => handleKeyDown(e, ssnOne)}
                      onChange={(e) => {
                        const val = e.target.value[0] ? e.target.value[0] : "";

                        setUserSSN((prev) => ({
                          ...prev,
                          one: val,
                        }));
                        setError({ status: false, message: "" });
                        if (val !== "") ssnTwo.current.focus();
                      }}
                      placeholder="*"
                    />
                  </div>
                  <div>
                    <input
                      id="two"
                      ref={ssnTwo}
                      className="ssn-input"
                      type="number"
                      onKeyDown={(e) => handleKeyDown(e, ssnOne)}
                      onChange={(e) => {
                        const val = e.target.value[0] ? e.target.value[0] : "";
                        setUserSSN((prev) => ({
                          ...prev,
                          two: val,
                        }));
                        setError({ status: false, message: "" });
                        if (val !== "") ssnThree.current.focus();
                      }}
                      placeholder="*"
                      value={userSSN.two}
                    />
                  </div>
                  <div>
                    <input
                      id="three"
                      ref={ssnThree}
                      className="ssn-input"
                      type="number"
                      onKeyDown={(e) => handleKeyDown(e, ssnTwo)}
                      onChange={(e) => {
                        const val = e.target.value[0] ? e.target.value[0] : "";
                        setUserSSN((prev) => ({
                          ...prev,
                          three: val,
                        }));
                        setError({ status: false, message: "" });
                        if (val !== "") ssnFour.current.focus();
                      }}
                      placeholder="*"
                      value={userSSN.three}
                    />
                  </div>
                  <div>
                    <input
                      id="four"
                      ref={ssnFour}
                      className="ssn-input"
                      type="number"
                      onKeyDown={(e) => handleKeyDown(e, ssnThree)}
                      onChange={(e) => {
                        const val = e.target.value[0] ? e.target.value[0] : "";
                        setUserSSN((prev) => ({
                          ...prev,
                          four: val,
                        }));
                        setError({ status: false, message: "" });
                      }}
                      placeholder="*"
                      value={userSSN.four}
                    />
                  </div>
                </div>
                {error.status && (
                  <div className="error-text">{error.message}</div>
                )}
              </div>
              <button
                onClick={(e) => onSubmit(e, userSSN)}
                className="mt-3 mb-0 px-5"
                type="button"
              >
                Submit <Image src={getAssetURL("arrow-icon.svg")} />
              </button>
            </div>
          </Form>
        </Col>
        <Col
          className="right-col order-1 order-lg-2 d-flex m-0 p-0 justify-content-center align-items-start"
          lg={6}
        >
          <Image
            className="hide-img"
            fluid
            src={getAssetURL("mobile-sidethree.png")}
          />
        </Col>
      </Row>
    </Container>
  );
};
export default PageThree;
